import { render, staticRenderFns } from "./CreateOrderPage.vue?vue&type=template&id=8953522c&scoped=true&"
import script from "./CreateOrderPage.vue?vue&type=script&lang=js&"
export * from "./CreateOrderPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderPage.vue?vue&type=style&index=0&id=8953522c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8953522c",
  null
  
)

export default component.exports